import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface eventInitialSliceI {
  totalPages: number;
  totalRecords: number;
}

const initialState: eventInitialSliceI = {
  totalPages: 0,
  totalRecords: 0
};

export const eventSlice = createSlice({
  name: 'eventSlice',
  initialState,
  reducers: {
    setEventTotalPages: (
      state: eventInitialSliceI,
      actions: PayloadAction<eventInitialSliceI>
    ) => {
      state.totalPages = actions.payload.totalPages;
      state.totalRecords = actions.payload.totalRecords;
    }
  }
});
